import type { StatCardData, TimekeepingStatus } from '@/types/timekeeping';

export const STATUS_OPTIONS: readonly TimekeepingStatus[] = [
  'Đủ công',
  'Tăng ca',
  'Đi trễ',
  'Về sớm',
  'Đã check-in',
  'Vắng không lương',
  'Vắng có lương',
  'Vắng mặt',
] as const;

// Các trạng thái có thể chọn trong modal (chỉ các trạng thái vắng có lương và không lương)
export const MODAL_STATUS_OPTIONS: readonly TimekeepingStatus[] = [
  'Vắng không lương',
  'Vắng có lương',
] as const;

export const STAT_CARDS_TEMPLATE: readonly StatCardData[] = [
  {
    title: 'Cần kiểm tra',
    value: 0,
    description: 'Nhân sự thiếu giờ Ra/Vào',
    iconSrc: 'list-checks.svg',
    iconAlt: 'Cần kiểm tra',
  },
  {
    title: 'Đi trễ / Về sớm',
    value: '0 phút',
    description: '0 nhân sự vi phạm',
    iconSrc: 'timer-off.svg',
    iconAlt: 'Đi trễ / Về sớm',
  },
  {
    title: 'Tăng ca',
    value: '0h',
    description: '0 nhân sự tăng ca',
    iconSrc: 'clock-plus.svg',
    iconAlt: 'Tăng ca',
  },
  {
    title: 'Đủ công',
    value: 0,
    description: '0 nhân sự vắng mặt',
    iconSrc: 'clock-check.svg',
    iconAlt: 'Đủ công',
  },
] as const;


